





















import timeFormat from '@/utils/timeFormat';

export default {
  computed: {
    time: {
      get() {
        const that: any = this;
        return [that.$store.state.rocketbot.durationRow.start, that.$store.state.rocketbot.durationRow.end];
      },
      set(val: Date[]) {
        const that: any = this;
        that.$store.dispatch('SET_DURATION', timeFormat(val));
      },
    },
  },
};
